module.exports = __webpack_public_path__ + "img/3地理标志保护.dfaf8072.png";